"use strict";
/**
* Предоставляет работу со списками объектов  в проводнике.
* Например, получить список отфильтрованных объектов – задач, заданий и уведомлений в проводнике, выделить объекты в списке закладок,
* снять выделение с элементов табличной части справочника.
*
* @class WebAccess.components.wrappers.objectList.ObjectsAsTable
* @since 5.2.0.2004
*/

(function (global) {

  var ObjectsTable = global.CMP.wrappers.objectList.ObjectList.extend({
    className: 'ObjectsTable',

    init: function (containerSelector) {
      var me = this;
      me._items = {};
      me._selectedItems = {};
      me._super(containerSelector);
      Core.toolBars.main.enableCheckBoxOnItemsSelect();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    // Устанавливает ссылку на текущий грид.
    _setGrid: function () {
      var me = this;
      me._grid = Core.grid.reference;
      me._slickGrid = me._grid.grid;
      me._slickGridDataView = me._grid.dataView;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить элементы списка.
    *
    * @method WebAccess.components.wrappers.objectList.ObjectList.getItems
    * @comment Keit_B: в справке не нашла. Пока не трогаю.
    * @return {WebAccess.components.wrappers.objectList.ListItem[]}
    */
    getItems: function () {
      return this._items;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * При AJAX автоподгрузке элементов, надо обновлять список объектов.
    *
    * @method WebAccess.components.wrappers.objectList.ObjectList._onItemsChanged
    * @private
    * @return {WebAccess.components.wrappers.objectList.ListItem[]}
    */
    _onItemsChanged: function () {
      var me = this;
      me._setGrid();
      var rowsData = me._slickGrid.getData().getItems();
      me._items = {};
      _(rowsData).each(function (rowData) {
        if (!isNaN(rowData.id)) {
          var itemData = {
            id: +rowData.id,
            name: rowData.__name,
            code: rowData.__code,
            kind: 'REF',
            type: objectKindToObjectType('REF'),
            referenceName: me._grid.state.ReferenceName,
            referenceCode: me._grid.state.ReferenceName,
            isSelected: true
          };
          var itemSelector = '#' + rowData.id;
          var jItem = $(itemSelector);
          if (jItem.hasClass('Task_obj') || jItem.hasClass('Job_obj')) {
            me._items[+rowData.id] = new global.components.wrappers.objectList.CustomWorkListItem(itemSelector, true, itemData);
          } else {
            me._items[+rowData.id] = new global.components.wrappers.objectList.ListItem(itemSelector, true, itemData);
          }
        }
      });
      me.fire("onChange", me.getSelectedItems(), me._items);
      return me._items;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получает выделеннные элементы списка.
    * @method WebAccess.components.wrappers.objectList.ObjectList.getSelectedElements
    * @return {WebAccess.components.wrappers.objectList.ListItem[]}
    */
    getSelectedItems: function () {
      var me = this;
      me._setGrid();
      var selectedRowIds = me._slickGridDataView.getSelectedRowIds();

      // Сохраняем выделенные объекты в переменной для возможности получения их с любой страницы.
      // Формировать новый объект нужно, т.к. галочки могут быть сняты, а грид возвращает всегда только текущие выделенные.
      var newSelectedItemsData = {};
      _(selectedRowIds).each(function (rowIdStr) {
        if (typeof rowIdStr !== "undefined") {
          var rowId = +rowIdStr;
          newSelectedItemsData[rowId] = me._items[rowId] || me._selectedItems[rowId];
        }
      });
      me._selectedItems = newSelectedItemsData;

      return _.toArray(me._selectedItems);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * При клике на чекбокс, вызовем свое событие.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList._onItemSelected
     * @private
     * @return {WebAccess.current.objectList}
     */
    _onItemSelected: function (item) {
      this.fire('onSelect', item, this.getSelectedItems());
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Выделить все объекты списка.
    * @method WebAccess.components.wrappers.objectList.ObjectList.selectAll
    * @return {WebAccess.current.objectList}
    */
    selectAll: function () {
      var me = this;
      me._isAllSelected = true;

      me._setGrid();
      var rowsData = me._slickGrid.getData().getItems();
      var selectedRowNums = _.range(rowsData.length);
      me._slickGrid.setSelectedRows(selectedRowNums);

      me._raiseOnSelectEvent('last');

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Снять выделение со всех элементов списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.deselectAll
     * @return {WebAccess.current.objectList} Специальный deferred-объект.
     */
    deselectAll: function () {
      var me = this;
      me._isAllSelected = false;

      me._setGrid();
      me._slickGrid.setSelectedRows([]);

      me._raiseOnSelectEvent(null);

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Выделить элемент списка.
     * @method WebAccess.components.wrappers.objectList.ObjectList.selectAll
     * @return {WebAccess.current.objectList}
     */
    selectItemByID: function (id) {
      var me = this;

      me._setGrid();
      var selectedRowNums = me._slickGrid.getSelectedRows();
      selectedRowNums.push(me._slickGrid.getData().getIdxById(+id));
      me._slickGrid.setSelectedRows(selectedRowNums);

      me._raiseOnSelectEvent(me._items[+id]);

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Инвертировать выделение всех объектов списка.
     *
     * @method WebAccess.components.wrappers.objectList.ObjectList.invertSelection
     * @return {WebAccess.current.objectList} Специальный deferred-объект.
     */
    invertSelection: function () {
      var me = this;

      me._setGrid();

      var selectedRowNums = me._slickGrid.getSelectedRows();

      var rowsData = me._slickGrid.getData().getItems();
      var allItemNums = _.range(rowsData.length);

      var newSelectedRowNums = _.difference(allItemNums, selectedRowNums);
      me._slickGrid.setSelectedRows(newSelectedRowNums);

      me._raiseOnSelectEvent('last');

      return me;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    _raiseOnSelectEvent: function (item) {
      var me = this;

      UpdateSelectionNumbers();
      var selected = me.getSelectedItems() || [];
      if (item === 'last') {
        var lastSelected = null;
        if (selected.length > 0) {
          lastSelected = selected[selected.length - 1];
        }
        me.fire('onSelect', lastSelected, selected);
      } else {
        me.fire('onSelect', item, selected);
      }
    },

    /**
    * Получить объекты списка, отфильтрованные селектором.
    *
    * @method WebAccess.components.wrappers.objectList.ObjectList.getFilteredItems
    * @return {WebAccess.components.wrappers.objectList.ListItem[]} Специальный deferred-объект.
    */
    getFilteredItems: function (filterSelector) {
      if (filterSelector === '.selected') {
        return this.getSelectedItems();
      }
      throw new Error("Not supported.");
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  global.CMP.wrappers.objectList.ObjectsTable = ObjectsTable;

})(window.WebAccess);
